<template>
  <div class="page">
    <div class="book-wrap">
      <div class="book-img">
        <van-image fit="cover" :src="bookItem.firstImgPath" radius="5px">
        </van-image>
      </div>
      <div class="book-info">
        <div class="book-title">
          <span v-text="bookItem.title"></span>
        </div>
        <div
          class="column"
          v-for="(item, index) in bookItem.formatDes"
          :key="index"
          v-show="
            item.length > 0 &&
            !(item.indexOf('【简介】') >= 0 || item.indexOf('【简 介】') >= 0)
          "
        >
          <span
            class="word"
            v-text="item"
            :style="{ paddingLeft: item.indexOf('【') < 0 ? '5px' : '0' }"
          ></span>
        </div>
      </div>
    </div>
    <div
      class="book-desc"
      v-for="(item, index) in bookItem.formatDes"
      :key="index"
      v-show="item.indexOf('【简介】') >= 0 || item.indexOf('【简 介】') >= 0"
    >
      <span v-text="item"></span>
    </div>
  </div>
</template>
<script>
import { getSessionStorage } from "@/utils";
import { newBookGet } from "@/api/home";
import { STATUS_CODE_OK } from "@/config";
export default {
  name: "NewBookDetail",
  data() {
    return {
      newBookList: [],
      bookItem: {},
    };
  },
  async created() {
    let title = this.$route.query.title;
    let sessionItem = getSessionStorage("queryParam");
    if (title) {
      this.bookItem = await this.handleNewBookGet(
        window.decodeURIComponent(title)
      );
    } else if (sessionItem) {
      this.bookItem = sessionItem;
    }
  },
  methods: {
    // 获取新书推荐
    async handleNewBookGet(title) {
      let bookItem = {};
      let { data } = await newBookGet();
      if (data.code === STATUS_CODE_OK) {
        this.newBookList = data.data.map((item) => {
          item.formatDes = item.description.split("【");
          item.formatDes.forEach((fItem, index) => {
            if (fItem.indexOf("】") >= 0) {
              item.formatDes[index] = "【" + fItem;
            }
          });
          return item;
        });
        bookItem = this.newBookList.find((item) => item.title === title);
        return bookItem;
      } else {
        return bookItem;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .book-wrap {
    display: flex;
    background: #fff;
    padding: 10px;
    .book-img {
      flex: 0 0 120px;
      box-sizing: border-box;
    }
    .book-info {
      margin-left: 5px;
      flex: 1;
      .book-title {
        font-size: 16px;
        padding-left: 5px;
      }
      .column {
        margin-top: 6px;
        font-size: 12px;
        color: #777;
      }
    }
  }
  .book-desc {
    background: #fff;
    padding: 0 10px 10px 10px;
    text-indent: 2em;
    color: #777;
  }
}
</style>
